<template>
  <div class="section">
    <div class="container">
      <div>
        <h1>Thank You</h1>
        <p>
          Your payment has been processed.<br />
          Please check your email for instuctions on how to finish creating your account.
        </p>
        <p>
          Certified for transaction scorecards will be available for download from the 'Purchase History' menu option.
        </p>
        <p>
          <ul>
            <li><router-link to="/index">Return to the Index</router-link></li>
            <li><router-link to="/history">View Purchase History</router-link></li>
          </ul>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    methods: {

    },
    created() {

    },
    mounted() {

    }
  }
</script>
